import { TrendingUp, Globe, Zap } from 'lucide-react'
import { SidebarSection } from './sidebar-section'
import { SidebarItem } from './sidebar-item'

interface TrendsSectionProps {
  sidebarCollapsed: boolean
  onItemClick: () => void
}

export function TrendsSection({ sidebarCollapsed, onItemClick }: TrendsSectionProps) {
  const trendsItems = [
    { name: 'Social Trends', href: '/trends/social', icon: TrendingUp },
    { name: 'Global Trends', href: '/trends/global', icon: Globe },
    { name: 'Deep Intelligence', href: '/trends/deep-intel', icon: Zap },
  ]

  return (
    <SidebarSection
      title="Trends"
      icon={<TrendingUp className="h-4 w-4" />}
      sidebarCollapsed={sidebarCollapsed}
      defaultOpen={true}
    >
      {trendsItems.map((item) => (
        <SidebarItem
          key={item.name}
          name={item.name}
          href={item.href}
          icon={item.icon}
          sidebarCollapsed={sidebarCollapsed}
          onClick={onItemClick}
        />
      ))}
    </SidebarSection>
  )
}
